var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-base',{staticClass:"card-strategy"},[_c('social-icon',{attrs:{"type":_vm.channel,"size":57}}),_c('h5',{staticClass:"semibold-20 card-strategy__title mrg-top-8"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"regular-14"},[_vm._v(" "+_vm._s(_vm.description)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }